module.exports = __webpack_public_path__ + "static/img/9.6aa75cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/9.png
// module id = 6GAV
// module chunks = 0